import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BetSlipList from 'views/betslip/bet_slip';
import { countSlipEntries } from 'toolkit/betBuilder';

export default function RightSidebar() {
  const betSlipBetsLength = useSelector((state) => state.betSlip.bets.length);
  const betSlipEntryCount = useSelector((state) => countSlipEntries(state.betSlip.bets));
  const { t } = useTranslation('translations', { useSuspense: false });

  return (
    <div className="betslip-sidebar">
      <div className="card">
        <div className="card-header d-flex justify-content-center align-item-center text-primary">
          {t(`pages.desktop.bettingSlip.bettingSlip`)}
          {betSlipBetsLength > 0 ? (
            <span className="betslip-title-badge">{betSlipEntryCount}</span>
          ) : (
            ''
          )}
        </div>
        {betSlipBetsLength > 0 ? (
          <BetSlipList type={'desktop'} />
        ) : (
          <div className="card-body py-4">
            <h6 className="mb-1 d-flex justify-content-center align-item-center">
              {t(`pages.desktop.bettingSlip.noBetsSelected`)}
            </h6>
            <small className="d-flex justify-content-center align-item-center text-muted">
              {t(`pages.desktop.bettingSlip.pleasePlaceBet`)}
            </small>
          </div>
        )}
      </div>
    </div>
  );
}
